const styles = `:host{padding:0 var(--goto-spacing-04);margin-bottom:var(--goto-spacing-04)}`;export default styles;